// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes shimmer-loading--uhxVH{0%{background-position:200% 0}100%{background-position:-200% 0}}.content-placeholder--fJVre{background:linear-gradient(to right, #e9e9e9 40%, #f4f4f4 50%, #e9e9e9 60%);animation:load--QVcPk 1.3s infinite linear;background-size:400%;background-position-x:100%}@keyframes load--QVcPk{to{background-position-x:0%}}.content-placeholder--fJVre.block--LtLRE{height:100%;width:100%;left:0;top:0;position:absolute}.content-placeholder--fJVre.circle--OV69_{border-radius:50%}.content-placeholder--fJVre.single-line-text--pCkfO{height:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content-placeholder": "content-placeholder--fJVre",
	"load": "load--QVcPk",
	"block": "block--LtLRE",
	"circle": "circle--OV69_",
	"single-line-text": "single-line-text--pCkfO",
	"shimmer-loading": "shimmer-loading--uhxVH"
};
export default ___CSS_LOADER_EXPORT___;
